import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/Store';
import { UserInfoDialogContext } from './store/context/userInfoDialogContext';
import { NetCallContext } from './store/context/netCallContext';
import ReduxHeader from './components/common/Header.jsx';
import { PayPage } from './components/common/pay/PayPage';
import ReduxCompanyLeadsManagePage from './components/pages/leadsmanage/Company';
import OffocialAccountsAuthPage from './components/pages/offocialAccounts/auth';
import ReduxLoading from './components/common/Loading';
import ReduxTips from './components/common/Tips';
import HomePage from './components/pages/home/HomePage';
import PrivilegeCode from './consts/PrivilegeCode';
import { RPCFactory } from './utils/RequestUtil';
import { PageUtil } from './utils/PageUtil';
import { judgeIsFromTMC } from './utils'
import { AuthConfirmPage } from './components/pages/auth/AuthConfirmPage';
import { LogoutPage } from './components/pages/auth/LogoutPage';
import SecondLoginPage from './components/pages/secondLogin/SecondLoginPage';
import OfflineTaskCenter from './components/pages/importCenter';
import Guide from './components/pages/guide';
import CallTip from './components/pages/guide/callTip';
import { ProtectLawTip } from './components/pages/guide/protectLawTip';
import { NoticeCenter } from './components/pages/noticeCenter/noticeCenter';
import { MenuLv2, MenuLv3 } from './components/common/DispersiveMenu';
import NoPermission from './components/pages/auth/NoPermission';
import IconList from './components/pages/debug/IconList';
import Tips from './components/Tips';
import { OperateLogs as Logs, canIUseLogs } from './components/pages/logs';
import { beaconInstance, aegis } from './instrumentation/beaconSetup';
import Dialog from './components/Dialogs/NewFeatures';
import FreeLoginDialog from './components/Dialogs/FreeLogin';
import { withNetCall } from './components/common/call/withNetCall';
import { withVersionUpdateDialog } from './components/common/versionControl/withVersionUpdateDialog';
import Skeleton from './components/common/skeleton';
import '../style/less/style.less';

const getQueryVariable = (variable) => {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
};

if (!window.pageProps || !window.pageProps.token) {
  window.pageProps = {};
  window.pageProps.from = getQueryVariable('from');
  if (window.location.pathname.indexOf('advertiser') == -1) {
    window.pageProps = {
      index: true,
      env: 'dns',
    };
  } else {
    const cidA = location.pathname.match(/[0-9]+/);
    const uid = cidA ? cidA[0] : null;
    window.pageProps = {
      uid,
    };
    aegis.setConfig({
      uin: uid,
    })
  }
}

if (judgeIsFromTMC()) {
  document.getElementsByTagName('body')[0].classList.add("from-tmc");
}


class App extends React.PureComponent {
  constructor(props) {
    super(props);
    const destinationPage = getQueryVariable('dest');
    if (destinationPage && !(location.hash.indexOf(`#/${destinationPage}`) == 0)) {
      location.hash = `#/${destinationPage}`;
    }
    this.state = {
      sideBarType: '',
      initComplete: false,
      isIframe: getQueryVariable('from') === 'xd' || getQueryVariable('from') === 'tmc' || window.location.hash === '#/manageIframe',
      destinationPage: getQueryVariable('dest'),
      authedRoutes: null,
      showUserInfoDialog: false,
      xundaData: { poolName: '', pools: [] },
    };
    this.checkLoginAndInit();
  }

  checkLoginAndInit = () => {
    // 从企微环境进入的平台
    if (getQueryVariable('from') === 'qw') {
      // this.init();
      PageUtil.initWithCallback(this.initCallback);
      window.pageProps.source = 'qw';
    } else {
      const urlQuery = new URLSearchParams(window.location.search);
      const urlQueryParams = {};
      urlQuery.forEach((value, key) => {
        urlQueryParams[key] = value;
        if (key === 'from' && !['mp', 'xd', 'tmc'].includes(value)) {
          // from 参数只能是 mp 或者 xd 或者tmc
          delete urlQueryParams[key];
        }
      });
      if (window.location.hash) {
        urlQueryParams.dest = window.location.hash.replace('#/', '');
      }
      RPCFactory.checkLogin
        .advertiserPageLogin(urlQueryParams)
        .done((result) => {
          if (result && result.success) {
            if (result.isQQlogin) {
              window.pageProps.ssoMultiAccountLoginName = result.qqNumber;
              window.pageProps.ssoMultiAccountLoginType = 1;
            }
            window.pageProps.authenticationWay = result.authenticationWay;
            // this.init();
            PageUtil.initWithCallback(this.initCallback);

            if (judgeIsFromTMC()) {
              top.postMessage({ type: 'loginChecked' }, '*');
            }
          } else if (result) {
            window.location = result.ssoURL;
          }
        })
        .fail((ret, msg) => {
          alert(msg);
        });
    }
  };
  initCallback = (data) => {
    beaconInstance.addAdditionalParams({
      accountId: window.pageProps.uid,
      userId: data.operationUserId,
      from: getQueryVariable('from'),
    });
    beaconInstance.onUserAction('initialize', {});
    PageUtil.getWeixinUserNameDisplayEnv();
    this.setState({
      initComplete: true,
      privileges: window.pageProps.privileges,
      privilegesInWhite: window.pageProps.privilegesInWhite,
      authedRoutes: PageUtil.getAuthedRoutes(),
    });
    // RPCFactory.account.check_whitelist(window.pageProps.uid, 'qwAuth').done((data) => {
    //   if (data) {
    //     window.pageProps.qwAuthEnabled = true;
    //     this.setState({
    //       authedRoutes: PageUtil.getAuthedRoutes(),
    //     });
    //   }
    // });
  };
  setRouter = (routes) => {
    this.setState({ authedRoutes: routes });
  };
  onToggleSideBarType = (type) => {
    this.setState({ sideBarType: type });
  };

  isFansVisible = () => {
    const privileges = this.state.privileges ? this.state.privileges : [];
    return (
      privileges.includes(PrivilegeCode.WX_APP_AUTHORIZER_VIEW.getCode()) ||
      privileges.includes(PrivilegeCode.WX_APP_FANS_VIEW.getCode()) ||
      privileges.includes(PrivilegeCode.WX_APP_TAG_RECOG_RULE_VIEW.getCode()) ||
      privileges.includes(PrivilegeCode.WX_APP_MESSAGE_SENDING_RULE_VIEW.getCode())
    );
  };

  setUserInfoDialog = (showFlag) => {
    this.setState({ showUserInfoDialog: showFlag });
  };
  routerConfig() {
    const isObserver =
      window.pageProps.originRole == 'OPERATOR_ROLE_LEADS_OBSERVER' ||
      window.pageProps.originRole == 'OPERATOR_ROLE_LEADS_SUPER_OBSERVER';
    // 仅超级管理员、管理员、免登录有权限查看操作日志
    const canUseLogs = canIUseLogs();
    return (
      <NetCallContext.Provider
        value={{
          createRoom: this.props.createRoom,
          initSocket: this.props.initSocket,
          socket: this.props.socket,
          netCallLoggedIn: this.props.netCallLoggedIn,
          calloutState: this.props.calloutState,
          onCallUserUsingNetCall: this.props.onCallUserUsingNetCall,
        }}
      >
        <Switch>
          <Route path="/secondLogin" component={SecondLoginPage} />
          <Route path="/third" component={AuthConfirmPage} />
          <Route path="/logout" component={LogoutPage} />
          <Route path="/fan/official/offocialAccountsAuth" component={OffocialAccountsAuthPage} />
          <Route path="/message" component={(NoticeCenter)} />
          <Route path="/payDetailPage" component={(PayPage)} />
          {canUseLogs && (<Route path="/logs" component={Logs} />)}
          <Route path="/offlineTaskManage" component={OfflineTaskCenter} />
          {
            process.env.NODE_ENV === 'development' && (
              <Route path="/iconlist" component={IconList} />
            )
          }
          <Route path="/">
            <div className="wrapper">
              {!this.state.isIframe && <MenuLv2 />}
              <div className="sub-main">
                {!this.state.isIframe && <Tips />}
                {!this.state.isIframe && <MenuLv3 />}
                <Switch>
                  <Route key="iframe" path="/manageIframe" component={ReduxCompanyLeadsManagePage} />
                  {this.state.authedRoutes.map((item, index) => (
                    <Route
                      key={index}
                      path={item.path}
                      component={item.component}
                    />
                  ))}
                  <Route key="403" path="*" component={NoPermission} />
                </Switch>
              </div>
              {this.isFansVisible() && !this.state.isIframe && <Guide />}
              {!this.state.isIframe && <CallTip />}
              {!isObserver && !this.state.isIframe && <ProtectLawTip />}
              <ReduxLoading />
              <div className="global-dialogs">
                <Dialog />
                <FreeLoginDialog />
              </div>
            </div>
          </Route>
        </Switch>
      </NetCallContext.Provider>
    );
  }

  render() {
    if (!this.state.initComplete) {
      return <Skeleton />;
    }
    return this.state.isIframe ? (
      this.routerConfig()
    ) : (
      <div className="page-container with-sidebar">
        <UserInfoDialogContext.Provider
          value={{
            showUserInfoDialog: this.state.showUserInfoDialog,
            setUserInfoDialog: this.setUserInfoDialog,
            xundaData: this.state.xundaData,
            setRouter: this.setRouter,
          }}
        >
          <ReduxHeader privileges={this.state.privileges} setRouter={this.setRouter} />
          {this.routerConfig()}
          <ReduxTips />
        </UserInfoDialogContext.Provider>
      </div>
    );
  }

  componentDidMount() {
    // 获取行业状态
    RPCFactory.accountSettings.getIndustryTree()
      .done((data) => {
        store.dispatch({
          type: 'INDUSTRY_INIT',
          payload: data,
        });
      })
      .fail((ret, msg) => {
        console.error(`行业获取失败: ${msg}`);
      });
  }
}
const WithNetCallApp = withVersionUpdateDialog(withNetCall(App));
if (window.pageProps.index) {
  ReactDOM.render(<HomePage />, document.body);
} else {
  ReactDOM.render(
    <Provider store={store}>
      <Router>
        <WithNetCallApp />
      </Router>
    </Provider>,
    document.getElementById('container'),
  );
}

export default App;
